//@ts-check
import request from '../request';
import DataActionItem from '../../data/actions/item';
/**
 * Disables (pauses) a journey
 * @param {number} journeyId
 */

export var disable = function disable(journeyId) {
  return toggle(journeyId, false);
};
/**
 * Enables (starts) a journey
 * @param {number} journeyId
 */

export var enable = function enable(journeyId) {
  return toggle(journeyId, true);
};
/**
 * Toggles a journey enable/disable state
 * @param {number} journeyId
 * @param {boolean} enabled
 */

export var toggle = function toggle(journeyId, enabled) {
  return request({
    url: "/backend/journeys/".concat(journeyId, "/enabled"),
    method: 'PUT',
    contentType: 'json',
    data: enabled
  }).then(function () {
    //refresh items
    return DataActionItem({
      id: journeyId,
      dataType: 'journey'
    }).refresh();
  });
};
export default {
  enable: enable,
  disable: disable,
  toggle: toggle
};